<template>
  <div class="agreement">
    <div class="T_title" style="text-align: center">
      {{ appName }} User Agreement
    </div>
    <div class="T_content">
      Welcome to {{ appName }} (the "Platform" or "APP"). The Platform is
      provided by {{ appName }} (such entities collectively referred to as "{{
        appName
      }}
      ", "we", or "us").
    </div>
    <div class="T_content">
      You are reading the Terms of Service ("Terms"), which govern the
      relationship between you and us and serve as an agreement between you and
      us and set out the terms and conditions under which you may access and use
      the Platform and our related websites, services, applications, products
      and content (collectively, the "Services"). Access to certain Services or
      Service features (such as, but not limited to, the ability to submit or
      share User Content (defined below)) may be age-restricted and may not be
      available to all users of the Services. Our Services are intended for
      private, non-commercial use only. For the purposes of these Terms, "you"
      and "your" means you as a user of the Services.
    </div>
    <div class="T_content">
      These Terms constitute a legally binding agreement between you and us.
      Please take the time to read them carefully. If you are under the age of
      17, you may only use the Services with the consent of your parent or legal
      guardian. Please ensure that your parent or legal guardian has reviewed
      and discussed these Terms with you.
    </div>
    <br /><br />
    <div class="T_title">1. Changes to the Terms</div>

    <div class="T_content">
      We may revise these Terms from time to time, for example when we update
      the functionality of the Services, when we combine multiple apps or
      services operated by us or our affiliates into a combined service or app,
      or when there are regulatory changes. We will use commercially reasonable
      efforts to generally notify all users of any significant changes to these
      Terms, such as through a notice on our Platform, however, you should
      review the Terms periodically to check for such changes. We will also
      update the "Last Updated" date at the top of these Terms, which reflects
      the effective date of these Terms. Your continued access or use of the
      Services after the effective date of the new Terms constitutes your
      acceptance of the new Terms. If you do not agree to the new Terms, you
      must stop accessing or using the Services.
    </div>
    <br /><br />
    <div class="T_title">2. Your Account with Us</div>

    <div class="T_content">
      To access or use some of our Services, you must create an account with us.
      When you create this account, you must provide accurate and current
      information. You must maintain and promptly update your details and any
      other information you provide to us to ensure that such information
      remains current and complete.
      <br /><br />
      You must keep your account password confidential and not disclose it to
      any third party. If you know or suspect that any third party knows your
      password or has accessed your account, you may contact us through the
      Platform and notify us immediately at {{ appEmail }}. <br /><br />
      You agree that you are solely responsible (to us and to others) for the
      activity that occurs under your account.
      <br /><br />
      We reserve the right to disable your user account at any time, including
      if you fail to comply with any provision of these Terms, or if the
      activity occurring on your account, in our sole discretion, causes or may
      cause damage to or impairment of the Service or infringe or violate any
      third party rights, or violate any applicable law or regulation.
      <br /><br />
      If you no longer want to use our Services again and wish to delete your
      account, we can handle this for you. Please contact us at
      {{ appEmail }} and we will provide you with further assistance and guide
      you through the process. Once you choose to delete your account, you will
      not be able to reactivate your account or retrieve any content or
      information you have added. <br /><br />
    </div>
    <div class="T_title">3. Privacy</div>

    <div class="T_content">
      Your privacy is important to {{ appName }} . Please refer to our Privacy
      Agreement for our policies on how we collect, use and disclose information
      about you Personal Information, and how you can manage your online privacy
      when using the Services.
    </div>
    <br /><br />
    <div class="T_title">4. Use of the Service</div>

    <div class="T_content">
      Your access to and use of the Service is subject to these Terms and all
      applicable laws and regulations. You agree that you will abide by these
      Terms of Service and {{ appName }} 's Community Covenant, and will not:
      <br /><br />
      (a) create, upload, transmit, distribute or store any content that is
      inaccurate, unlawful, infringing, defamatory, obscene, pornographic, child
      exploitation and child abuse, invasive of privacy or publicity rights,
      harassing, threatening, abusive, inflammatory, or otherwise objectionable;
      <br /><br />
      (b) impersonate any person or entity, misrepresent your affiliation with
      any person or entity, or access another person's {{ appName }} account to
      obtain permission, forge another person's identity or information to
      transmit content through the Service, or engage in any other similar
      fraudulent activity; <br /><br />
      (c) defame, harass, abuse, threaten or defraud {{ appName }} users, or
      collect or attempt to collect personal information about users or third
      parties without their consent; <br /><br />
      (d) remove, circumvent, disable, damage or otherwise interfere with
      security-related features of the Service or User Content, as well as
      features that prevent or restrict the use or copying of content available
      through the Service, enforce limitations on the use of the Service or User
      Content, or remove Services or User Content;
      <br /><br />
      (e) reverse engineer, decompile, disassemble or otherwise attempt to
      discover the source code of the Services or any part thereof, except to
      the extent expressly permitted by the laws of your jurisdiction of
      residence;
      <br /><br />
      (f) modify, adapt, translate or build upon the Services or any part
      thereof, except and solely to the extent such activity is expressly
      permitted by applicable law notwithstanding this limitation;
      <br /><br />
      (g) interfere with or damage the Services or any user's enjoyment of them
      in any way, including by uploading or otherwise transmitting viruses,
      adware, spyware, worms or other malicious code;
      <br /><br />
      (h) manipulate identifiers in order to disguise the origin of any user
      content transmitted through the Services;
      <br /><br />
      (i) interfere with or disrupt the Services or servers or networks
      connected to the Services, or disobey any requirements, procedures,
      policies or regulations of networks connected to the Services; in any
      manner that could interfere with, disrupt, negatively affect or inhibit
      another user from fully enjoying the Services, or that could damage,
      disable, overburden or impair the functionality of the Services in any
      way;
      <br /><br />
      (j) attempt to circumvent any content filtering technology we employ, or
      attempt to access any Service or area of the Services that you are not a
      have access;
      <br /><br />
      (k) use the Service for any unlawful purpose, or in violation of any
      local, state, national or international law or regulation, including,
      without limitation, laws restricting, governing intellectual property and
      other proprietary rights, data protection and privacy.
      <br /><br />
      {{ appName }} assumes no responsibility for any User Content or any loss
      or damage arising therefrom, nor does {{ appName }} assume any liability
      for any mistakes, defamation, slander, libel, omissions, falsehoods, or
      profanity you may encounter while using the Service. You use the Service
      at your own risk. In addition, these rules will not create any private
      right of action or any reasonable expectation on the part of any third
      party that the Service will not contain any content that is prohibited by
      these rules. <br /><br />
      {{ appName }} assumes no liability for any statements or representations
      contained in User Content. {{ appName }} does not endorse any User
      Content, opinion, advice or recommendation expressed therein, and
      {{ appName }} expressly disclaims any and all liability related to User
      Content. To the maximum extent permitted by applicable law,
      {{ appName }} reserves the right to remove, screen or edit any User
      Content posted or stored on the Service at any time without notice,
      including where such User Content violates the Terms of Service Use or
      applicable law, and you are solely responsible for creating backup copies
      and replacing any User Content you post or store on the Service at your
      own expense. Any use of the Service in violation of the foregoing is a
      violation of these Terms of Service Use and may result in termination or
      suspension of your rights to use the Service. <br /><br />
    </div>
    <div class="T_title">5. Intellectual Property</div>

    <div class="T_content">
      A. Platform Materials. All right, title and interest in all materials on
      the Service (including but not limited to design, text, graphics, images,
      video, information, applications, software, music, sound and other files
      and the selection and arrangement thereof) (excluding UGC) (collectively,
      the "Platform Materials") are, as between the Company and you, owned by
      the Company and/or its third-party licensors. You acknowledge and agree
      that you do not acquire any ownership rights by downloading the Platform
      Materials or purchasing any Virtual Currency or Virtual Items. You agree
      that you may not modify, copy, distribute, frame, reproduce, republish,
      download, scrape, display, post, transmit or sell the Platform Materials,
      in whole or in part, in any form or by any means, or otherwise exploit the
      Platform Materials, without our express prior written permission. You
      acknowledge that you do not acquire any ownership rights in or to any
      Platform Materials posted by Company on the Services or any derivative
      works thereof. All rights not expressly granted in this Agreement are
      reserved by Company and its licensors, and no license is granted by
      estoppel, implication or otherwise.
      <br /><br />
      B. UGC. You represent and warrant that your UGC is original to you and
      that you own the rights to such content, including the right to grant all
      rights and licenses in this Agreement, and that Company assumes no
      third-party obligations or liabilities arising from the exercise of such
      rights and licenses. All of your UGC is your sole responsibility, and
      Company is not responsible for any material you (and other users) upload,
      post or otherwise make available. By uploading, distributing, transmitting
      or otherwise using your UGC in the Services, you grant us a perpetual,
      non-exclusive, transferable, royalty-free, sublicensable and worldwide
      license to use, host, reproduce, modify, adapt, publish, translate, create
      derivative works, distribute, perform and display your UGC in connection
      with operating, providing and promoting the Services. The Company does not
      guarantee the accuracy, quality or integrity of any UGC that appears in
      the Services. By using the Services, you acknowledge and accept that you
      may be exposed to material that you consider offensive or objectionable.
      You agree that the Company will not be liable for any UGC under any
      circumstances, including, but not limited to, errors in any UGC or any
      loss or damage resulting from the use of such UGC. The Company reserves
      the right to remove and permanently delete your UGC from the Services for
      any reason or no reason, with or without notice. You may notify the
      Company of any UGC that you believe violates this Agreement or other
      inappropriate user behavior by reporting it to our customer service.
    </div>
    <br /><br />
    <div class="T_title">6. Fees, Revenue and Payment</div>

    <div class="T_content">
      1. Fees
      <br />
      We will not charge you for use of the basic features of the Services.
      However, you may be required to pay fees to use certain features of the
      Services or to obtain Virtual Currency or Virtual Items. The price of
      using these features or obtaining such virtual currency or virtual items
      will be displayed on the Service.
      <br /><br />
      2. Earnings<br />
      You may earn earnings from us, other users and/or our third-party sponsors
      or business partners by using certain features of the Service or
      participating in certain of our activities. These earnings may initially
      be accumulated and deposited in our Service in the form of virtual credits
      (which may be called various names). You may apply to us to withdraw your
      outstanding virtual credits in accordance with the above requirements,
      provided that:
      <br />
      i) you are at least 18 years old, or above the legal age of majority in
      your country of nationality and country of residence (whichever is
      higher);
      <br />
      ii) your earnings are not derived from any criminal, illegal or unlawful
      behavior;
      <br />
      iii) you have not violated this Agreement, any other agreement with us or
      our affiliates and/or the Platform Rules.
      <br />
      If you do not meet the conditions specified above, you will not be able to
      withdraw your earnings. You can contact our customer service to find out
      how to meet these conditions, or correct your non-compliance to delete
      your earnings. Compensate you for any such losses.
      <br />B. The Company reserves the right to deny any user access to the
      Service for any reason (including but not limited to violation of the
      Terms) without prior notice. If you violate this Agreement, the Company
      reserves the right to issue you a warning about the violation or
      immediately terminate or suspend any or all accounts you have created
      using the Services. You agree that the Company is not required to notify
      you before terminating or suspending your account, but the Company may do
      so. <br />
      C. You understand that we may need to perform planned or unplanned repairs
      and maintenance on the Services. We shall not be liable to you and/or any
      third party if such circumstances cause the Services to be interrupted for
      a reasonable period of time. However, we will notify you as soon as
      possible.

      <br /><br />
    </div>
    <div class="T_title">7. Risks</div>

    <div class="T_content">
      You understand and agree that this software only provides you with a
      platform for information sharing and transmission, and you are responsible
      for all actions under your account, including any content you transmit and
      any consequences arising therefrom. You shall judge the content of this
      software and services on your own and bear all risks arising from the use
      of the services, including risks arising from reliance on the correctness,
      completeness or practicality of the content. We cannot and will not be
      liable for any losses caused by your actions.
      <br />If you find that anyone has violated this agreement or used this
      service in other improper ways, please inform us immediately and we will
      handle it in accordance with this agreement.<br />
      You understand and agree that we reserve the right to change, suspend,
      terminate, and update all or part of the service at our discretion based
      on various factors without prior notice.
      <br /><br />
    </div>
    <div class="T_title">8. Liability</div>

    <div class="T_content">
      If you have any illegal, unlawful, breach of contract, or infringement, we
      have the right to take any or all of the following measures at our
      discretion: issue a warning, disable your ability to use certain
      functions, terminate your access to the software, blacklist you, publish
      your breach of contract, partially or completely deduct and withhold
      virtual items and virtual earnings. If we take measures to terminate your
      account and blacklist you, we have the right not to refund your virtual
      items and earnings.
      <br /><br />
      You understand and agree that we have the right to take any remedial
      measures, take appropriate legal actions against your illegal, unlawful,
      breach of contract, and tortious behavior, and disclose relevant
      information to relevant departments in accordance with laws and
      regulations, and you shall bear all consequences.
      <br /><br />
      You understand and agree that any losses, damages, and third-party claims
      arising from your violation of this Agreement shall be borne by you,
      including reasonable attorney fees.
      <br /><br />
      You agree to indemnify, defend and hold us and our affiliates harmless
      from the following: and all complaints, demands, claims, damages, losses,
      expenses, liabilities and costs, including but not limited to attorney
      fees, arising from your access or use of this service and your violation
      of this agreement.
      <br /><br />
    </div>
    <div class="T_title">9. Disclaimer</div>

    <div class="T_content">
      You shall bear full responsibility for any risks involved in the use of
      {{ appName }} 's services. Any use or reliance on {{ appName }} 's
      services will be at your own risk. <br /><br />
      In any case, {{ appName }} does not guarantee that the service will meet
      your requirements, nor does it guarantee the timeliness, security and
      accuracy of the service. You acknowledge and agree that
      {{ appName }} provides services on an "as is" basis. {{ appName }} makes
      no representations or warranties, express or implied, regarding the
      operation and provision of such services or any part thereof.
      {{ appName }} assumes no responsibility for the quality, timeliness,
      accuracy or completeness of the Services, nor for any consequences that
      may arise from your use of such Services. <br /><br />
      {{ appName }} does not guarantee the accuracy and completeness of any
      external links accessible using the Services and/or placed for your
      convenience. {{ appName }} is not responsible for the content of any
      linked website or any link contained in a linked website, nor is
      {{ appName }} liable, directly or indirectly, for any loss or damage
      related to your use of the Services. In addition, {{ appName }} is not
      responsible for the content of any web pages that you are directed to via
      external links that are not controlled by {{ appName }} . <br /><br />
      {{ appName }} shall not be liable for interruptions or other deficiencies
      in the Services caused by force majeure or circumstances beyond the
      control of {{ appName }} . However, {{ appName }} shall try to minimize
      the losses and effects caused to you as much as reasonably possible.
      <br /><br />
    </div>
    <div class="T_title">10. Contact Us</div>

    <div class="T_content">
      If you have questions about this Agreement, please send your comments or
      suggestions to our email {{ appEmail }}. We will review the issues
      involved and respond promptly. <br /><br />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  created() {},
};
</script>

<style scoped>
.agreement {
  padding: 0px 25px;
}
.T_title {
  font-size: 1.3rem;
  font-weight: 600;
  margin: 0.5333rem 0px;
  color: #000;
}
.T_content {
  font-size: 1rem;
  margin-bottom: 0.4667rem;
  color: #666;
}
.title_content {
  font-size: 1rem;
  margin-bottom: 0.4667rem;
  color: #666;
  margin-left: 0.4rem;
  margin-right: 0.4rem;
}
</style>
